import { render, staticRenderFns } from "./MessageToolbar.vue?vue&type=template&id=93f25954&scoped=true&"
import script from "./MessageToolbar.vue?vue&type=script&lang=js&"
export * from "./MessageToolbar.vue?vue&type=script&lang=js&"
import style0 from "./MessageToolbar.vue?vue&type=style&index=0&id=93f25954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f25954",
  null
  
)

export default component.exports